import React from 'react';
import './App.css';

// Import new components
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Insights from './components/Insights';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CookieConsentBanner from './components/CookieConsentBanner';

// Import translation provider
import { TranslationsProvider } from './hooks/useTranslations';

function App() {
  return (
    <TranslationsProvider>
      <div className="App">
        <Header />
        <main className="relative">
          <Hero />
          <Services />
          <About />
          <Insights />
          <Contact />
        </main>
        <Footer />
        <CookieConsentBanner />
      </div>
    </TranslationsProvider>
  );
}

export default App;
